import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchMaterialHeaders } from '@/api/my-styles';

export function materialHeadersQueryOptions(styleId: string) {
  return queryOptions({
    queryKey: ['my-styles', 'materials', 'headers', styleId] as const,
    queryFn: () =>
      fetchMaterialHeaders({
        styleId,
        page: 1,
        limit: 500,
        sort: 'name',
        order: 'asc',
      }),
    enabled: Boolean(styleId),
  });
}

export function useMaterialHeaders(styleId: string) {
  return useQuery(materialHeadersQueryOptions(styleId));
}
